const ColorSelector = ({ colors, selectedColor, setSelectedColor }) => {
    const colorMap = {
      red: "bg-red-600",
      black: "bg-black",
      gray: "bg-gray-400",
      white: "bg-white border border-gray-300",
    };
  
    return (
      <div className="flex space-x-2">
        {colors.map((color) => (
          <button
            key={color}
            onClick={() => setSelectedColor(color)}
            className={`w-8 h-8 rounded-md ${colorMap[color]} ${
              selectedColor === color
                ? "ring-2 ring-offset-2 ring-black"
                : ""
            }`}
            aria-label={`Select ${color} color`}
          />
        ))}
      </div>
    );
  };
  
  export default ColorSelector;
  